import gql from 'graphql-tag';

const GET_SIGNUPS_V2_WITH_EVENTS_PAGINATED = gql`
  query GetSignupsV2WithEventsPaginated(
    $campaignOrderId: ID!
    $skip: Int
    $first: Int
    $startDate: String
    $endDate: String
    $attrMethod: String
    $attrWindow: Int
  ) {
    getSignupsV2WithEventsPaginated(
      campaignOrderId: $campaignOrderId
      skip: $skip
      first: $first
      startDate: $startDate
      endDate: $endDate
      attrMethod: $attrMethod
      attrWindow: $attrWindow
    ) {
      total
      signups {
        id
        signUpId
        signUpDate
        totalImpressions
        lastImpression
        attrMethod
        attrValue
        attrWindow
      }
    }
  }
`;

export default GET_SIGNUPS_V2_WITH_EVENTS_PAGINATED;
